import { useRef, useState } from "react";
import { ApiError, request } from "../api/client";

/** Unknown outcomes keep their reviewed payload and request identity for an exact retry. */
export function useSetupMutation<T = unknown>(onSaved: (result: T) => void) {
  const [busy, setBusy] = useState(false);
  const [uncertain, setUncertain] = useState(false);
  const [error, setError] = useState<unknown>();
  const [saved, setSaved] = useState(false);
  const attempt = useRef<{ path: string; method: "PUT" | "POST"; body: object } | null>(null);
  async function send(path?: string, method: "PUT" | "POST" = "PUT", body?: object) {
    if (busy) return;
    if (!attempt.current && path && body) attempt.current = { path, method, body: { ...body, requestId: crypto.randomUUID() } };
    if (!attempt.current) return;
    setBusy(true); setError(undefined); setSaved(false);
    try {
      const result = await request<T>(attempt.current.path, attempt.current.method, attempt.current.body);
      attempt.current = null; setUncertain(false); setSaved(true); onSaved(result);
    } catch (e) {
      const unknown = !(e instanceof ApiError) || e.status >= 500;
      if (!unknown) attempt.current = null;
      setUncertain(unknown); setError(e);
    } finally { setBusy(false); }
  }
  function resetFeedback() { if(!busy&&!uncertain&&!attempt.current){setError(undefined);setSaved(false);} }
  return { send, busy, uncertain, error, saved, resetFeedback };
}
